<template>
  <div class="chit-modifier" :style="{ paddingLeft: depth * 12 + 'px' }">
    <div class="chit-modifier__row">
      <span class="chit-modifier__plus">+</span>
      <span class="chit-modifier__name">{{ primaryText }}</span>
      <span v-if="quantity > 1" class="chit-modifier__qty">x{{ quantity }}</span>
    </div>
    <div v-if="secondaryText" class="chit-modifier__description">{{ secondaryText }}</div>
    <ChitModifier
      v-for="(child, index) in children"
      :key="index"
      :modifier="child"
      :depth="depth + 1"
      :name-field="nameField"
      :show-description="showDescription"
      :description-field="descriptionField"
    />
  </div>
</template>

<script>
import { NAME_FIELD_KEYS } from "../kds.utils";

export default {
  name: "ChitModifier",
  props: {
    modifier: {
      type: Object,
      required: true,
    },
    depth: {
      type: Number,
      default: 0,
    },
    // Same contract as OrderChitItem — modifier rows follow the KDS name
    // setting too (M939), so this is threaded all the way down the tree.
    nameField: {
      type: String,
      default: "name1",
      validator: (v) => ["name1", "name2", "name3", "name4"].includes(v),
    },
    showDescription: {
      type: Boolean,
      default: false,
    },
    descriptionField: {
      type: String,
      default: "none",
      validator: (v) => ["none", "name1", "name2", "name3", "name4"].includes(v),
    },
  },
  computed: {
    // The BE already falls back to Name 1 when the chosen column is blank.
    primaryText() {
      return this.modifier[NAME_FIELD_KEYS[this.nameField]] || this.modifier.name || "";
    },
    secondaryText() {
      if (!this.showDescription) return "";
      const text =
        this.descriptionField === "none"
          ? this.modifier.description
          : this.modifier[NAME_FIELD_KEYS[this.descriptionField]] || this.modifier.name;
      return typeof text === "string" && text.trim() !== "" ? text : "";
    },
    quantity() {
      return Number(this.modifier.quantity ?? this.modifier.qty ?? 1);
    },
    children() {
      return this.modifier.children ?? [];
    },
  },
};
</script>

<style scoped>
.chit-modifier__row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: #45464d;
  padding: 2px 0;
}

.chit-modifier__description {
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #76777d;
  padding-left: 14px;
}

.chit-modifier__plus {
  flex: 0 0 auto;
  color: #76777d;
  font-weight: 900;
  margin-top: -1px;
}

.chit-modifier__name {
  flex: 1 1 auto;
}

.chit-modifier__qty {
  flex: 0 0 auto;
  margin-left: 8px;
  font-weight: 700;
}
</style>
